/* ============================================================
   Dahab Al-Hind — storefront behaviour
   {{ 'dahab.js' | asset_url | script_tag }}  (defer is fine)
   Handles: gallery, bundle selector, qty stepper, FAQ accordion,
            live totals in the order summary + sticky bar,
            smooth scroll to the COD checkout block.
   ============================================================ */
(function () {
  var money = function (cents, format) {
    // format example: "{{amount}} ر.س"  → we only need the amount slot
    var n = cents / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return (format || '{{amount}}').replace('{{amount}}', s).replace('{{amount_no_decimals}}', String(Math.round(n)));
  };

  function initProduct(root) {
    var fmt = root.getAttribute('data-money-format') || '{{amount}}';
    var main = root.querySelector('[data-dh-main-image]');
    var thumbs = root.querySelectorAll('[data-dh-thumb]');
    var bundles = root.querySelectorAll('[data-dh-bundle]');
    var qtyInput = root.querySelector('[data-dh-qty]');
    var variantInput = root.querySelector('[data-dh-variant]');
    var atcQty = root.querySelector('[data-dh-atc-qty]');

    /* gallery */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (main) {
          main.src = t.getAttribute('data-src');
          main.srcset = '';
        }
      });
    });

    /* bundles */
    function selectBundle(btn) {
      bundles.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
      var vid = btn.getAttribute('data-variant');
      var cents = parseInt(btn.getAttribute('data-price') || '0', 10);
      var title = btn.getAttribute('data-title') || '';
      if (qtyInput) qtyInput.value = qty;
      if (variantInput && vid) variantInput.value = vid;
      if (atcQty) atcQty.value = qty;
      document.querySelectorAll('[data-dh-sel-title]').forEach(function (el) { el.textContent = title; });
      document.querySelectorAll('[data-dh-sel-price]').forEach(function (el) { el.textContent = money(cents, fmt); });
      root.setAttribute('data-unit-price', cents);
      syncTotals();
    }
    bundles.forEach(function (b) {
      b.addEventListener('click', function () { selectBundle(b); });
    });

    /* qty */
    function step(d) {
      if (!qtyInput) return;
      var v = Math.max(1, Math.min(9, (parseInt(qtyInput.value, 10) || 1) + d));
      qtyInput.value = v;
      if (atcQty) atcQty.value = v;
      syncTotals();
    }
    var minus = root.querySelector('[data-dh-minus]');
    var plus = root.querySelector('[data-dh-plus]');
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { step(0); });

    function syncTotals() {
      var unit = parseInt(root.getAttribute('data-unit-price') || '0', 10);
      var q = parseInt((qtyInput && qtyInput.value) || '1', 10);
      var total = money(unit * q, fmt);
      document.querySelectorAll('[data-dh-total]').forEach(function (el) { el.textContent = total; });
      document.querySelectorAll('[data-dh-qty-out]').forEach(function (el) { el.textContent = q; });
    }

    var preselected = root.querySelector('[data-dh-bundle][aria-checked="true"]');
    if (preselected) selectBundle(preselected);
    else syncTotals();
  }

  function initFaq(root) {
    root.querySelectorAll('.dh-q > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.parentElement;
        var open = q.getAttribute('data-open') === 'true';
        root.querySelectorAll('.dh-q').forEach(function (o) {
          o.setAttribute('data-open', 'false');
          var i = o.querySelector('button i'); if (i) i.textContent = '+';
        });
        q.setAttribute('data-open', open ? 'false' : 'true');
        var icon = btn.querySelector('i'); if (icon) icon.textContent = open ? '+' : '\u2212';
      });
    });
  }

  /* smooth scroll to the COD checkout block */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-dh-goto]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('data-dh-goto'));
    if (!el) return;
    e.preventDefault();
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  });

  function boot() {
    document.querySelectorAll('[data-dh-product]').forEach(initProduct);
    document.querySelectorAll('[data-dh-faq]').forEach(initFaq);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  /* re-init after theme-editor section reloads */
  document.addEventListener('shopify:section:load', boot);
})();